import { createSelector } from 'reselect';

import { VIEW_NAMESPACE_DICTIONARY } from './constants';
import { initialState } from './reducer';

/**
 * Direct selector to the Change Email state domain
 */
const selectChangeEmailDomain = (state) => state.changeEmail || initialState;

/**
 * Other specific selectors
 */
const getChangeEmailConfirmationPageProps = () => createSelector(
  makeSelectChangeEmail('error'),
  makeSelectChangeEmail('status'),
  (errors, status) => {
    let errorOrSuccess = '';
    let message = '';
    const resetStep = 1;
    if (status && status.changeEmailStepTwo === 'succeeded') {
      errorOrSuccess = 'success';
    } else {
      const error = Object.entries(errors).find(([, value]) => !!value);
      if (error) {
        const [errorKey, errorValue] = error;
        errorOrSuccess = errorKey;
        message = errorValue;
      }
    }
    return { errorOrSuccess, message, resetStep };
  },
);

const getChangeEmailError = (prop) => createSelector(
  makeSelectChangeEmail('error'),
  (error) => error[prop],
);

const getChangeEmailForm = (prop) => createSelector(
  makeSelectChangeEmail('form'),
  getChangeEmailViewNamespace(),
  (form, viewNamespace) => form[prop || viewNamespace],
);

const getChangeEmailFormErrors = (prop) => createSelector(
  makeSelectChangeEmail('formErrors'),
  getChangeEmailViewNamespace(),
  (formErrors, viewNamespace) => formErrors[prop || viewNamespace],
);

const getChangeEmailNotifications = () => createSelector(
  makeSelectChangeEmail('bannerError'),
  makeSelectChangeEmail('serviceError'),
  (
    bannerError,
    serviceError,
  ) => {
    const nonFormErrors = [bannerError, serviceError];
    return nonFormErrors.filter((error) => !!error);
  },
);

const getChangeEmailViewNamespace = () => createSelector(
  makeSelectChangeEmail('step'),
  (step) => VIEW_NAMESPACE_DICTIONARY[step],
);

/**
 * Default selector used by Change Email
 */
const makeSelectChangeEmail = (prop) => createSelector(
  selectChangeEmailDomain,
  (state) => state[prop],
);

export default makeSelectChangeEmail;
export {
  getChangeEmailConfirmationPageProps,
  getChangeEmailError,
  getChangeEmailForm,
  getChangeEmailFormErrors,
  getChangeEmailNotifications,
  getChangeEmailViewNamespace,
};
